import React, { useEffect, useState } from "react";

import TrustPilotStar from "../../images/icons/trustpilotstar.inline.svg";
import ReviewsIcon from "../../images/icons/reviews-icon.inline.svg";
import {
  firestore,
  collection,
  where,
  query,
  getDocs,
  average,
  count,
  sum,
  getAggregateFromServer
} from "../../firebase";

const GviFlexTestimonialRating = ({
  programCode,
  containerClass = "flex gap-2 sm:gap-3 icon-wrapper justify-items-center items-center",
  iconClass = "w-5 h-5 fill-white planet:fill-gray-dark",
  descClass = "text-black-lighter planet:text-gray-dark",
  expandedScoreContainerClass = "text-black-lighter planet:text-gray-dark font-light md:font-bold",
  expandedCountContainerClass = "text-black-lighter planet:text-gray-nonary font-light pl-1",
  layout = "compact",
  currentBrand = "Planet",
  scrollToReviews,
  reviewsCount,
  setReviewsCount
}) => {
  const [reviewsAvgScore, setReviewsAvgScore] = useState(0);
  const [reviewsAvgScoreDecimal, setReviewsAvgScoreDecimal] = useState(0);

  const normaliseBrand =
    [currentBrand[0]?.toUpperCase(), currentBrand?.substring(1)].join("") ??
    currentBrand;

  async function getTestimonialStats() {
    const testimonialRef = query(
      collection(firestore, "marketing-stories"),
      where("TestimonialSiteBrand", "in", ["Both", normaliseBrand]),
      where("TestimonialProgramCode", "==", programCode),
      where("TestimonialShowOnWebsite", "==", true)
    );

    const stats = await getAggregateFromServer(testimonialRef, {
      count: count(),
      total: sum("TestimonialRating"),
      score: average("TestimonialRating")
    });

    return stats?.data() || { count: 0, total: 0, score: 0 };
  }

  useEffect(() => {
    getTestimonialStats().then((result) => {
      const { count, score } = result;
      const formattedScore = Math.round(score);
      const formattedScoreDecimal = score?.toFixed(2) ?? 0;

      setReviewsCount(count ?? 0);
      setReviewsAvgScore(formattedScore);
      setReviewsAvgScoreDecimal(formattedScoreDecimal);
    });
  }, [setReviewsCount]);

  if (reviewsCount < 1 || !programCode) {
    return <></>;
  }

  return (
    <div className={containerClass}>
      {layout === "new-expanded" ? (
        <ReviewsIcon className={iconClass} />
      ) : (
        <TrustPilotStar className={iconClass} />
      )}

      {layout === "compact" && (
        <div
          className={descClass}
          dangerouslySetInnerHTML={{
            __html: `${reviewsAvgScore}/10 (${reviewsCount})`
          }}
        />
      )}

      {layout === "expanded" && (
        <>
          <div
            className={expandedScoreContainerClass}
            dangerouslySetInnerHTML={{
              __html: `${reviewsAvgScore}/10`
            }}
          />
          <div
            className={expandedCountContainerClass}
            dangerouslySetInnerHTML={{
              __html: `(${reviewsCount} ${reviewsCount > 1 ? "reviews" : "review"})`
            }}
          />
        </>
      )}

      {layout === "flex-compact" && (
        <div
          className={descClass}
          dangerouslySetInnerHTML={{
            __html: `${reviewsAvgScoreDecimal} (${reviewsCount})`
          }}
        />
      )}

      {layout === "flex-expanded" && (
        <>
          <div
            className={expandedScoreContainerClass}
            dangerouslySetInnerHTML={{
              __html: `${reviewsAvgScoreDecimal}`
            }}
          />
          <div
            className={expandedCountContainerClass}
            dangerouslySetInnerHTML={{
              __html: `(${reviewsCount} ${reviewsCount > 1 ? "reviews" : "review"})`
            }}
          />
        </>
      )}

      {layout === "new-expanded" && (
        <>
          <div
            className={descClass}
            dangerouslySetInnerHTML={{
              __html: `${reviewsCount} participant reviews`
            }}
            onClick={scrollToReviews}
          />
        </>
      )}
    </div>
  );
};

export default GviFlexTestimonialRating;
